import React from "react";

import ExecutorArrivalTimeCellContent from "../components/ExecutorArrivalTimeCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function executorArrivalTime({ width, onResize }: Column.Options) {
	return base(
		ColumnId.ExecutorArrivalTime,
		(item) => <ExecutorArrivalTimeCellContent item={item} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default executorArrivalTime;
